import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {DataStore}                           from "@aws-amplify/datastore";
import {User}                       from "../../../models";
import {APIService, PermissionType} from "../../API.service";
import {SessionService}             from "../../services/session.service";
import {ToastController}            from "@ionic/angular";
import {NotificationService}      from "../../services/notification.service";
import {ComponentRef, Components} from "@ionic/core";
import IonList = Components.IonList;

@Component({
    selector: 'app-upload-files',
    templateUrl: './upload-files.component.html',
    styleUrls: ['./upload-files.component.css']
})
export class UploadFilesComponent implements OnInit {

    @Input() userId
    public currentUser: User;

@ViewChild('ionfilelist') ionfilelist: IonList;


constructor(private apiService: APIService,
                private notificationService: NotificationService,
                private sessionService: SessionService, private toastController: ToastController) {
    }

    async ngOnInit() {
        console.log("this.userId", this.userId);
        this.currentUser = await DataStore.query(User, this.userId)
        console.log(this.currentUser);
    }

    ionViewDidEnter() {

    }

    async updateFile(file: any) {

        console.log(file);
        let m = {
            id: this.currentUser.id,
        };

        m[file.name] = file.awsFile;
        try {
            let cUser = await DataStore.query(User, this.userId);
            this.currentUser = await DataStore.save(User.copyOf(cUser, u => {
                u[file.name] = file.awsFile;

            }));
            const msg = file?.awsFile ? "File caricato con successo" : "File eliminato con successo";
            const toast = await this.toastController.create({
                message: msg,
                duration: 3000,
            });

            if (file?.awsFile) {
                if (this.sessionService.user?.permessions == PermissionType.ADMINISTRATOR) {

                } else {
                  //  file.awsFile.validated = false;
                  //  await this.notificationService.notifyAdmin(`${this.currentUser.lastname}Documento " " caricato per il `);
                }
            } else {

            }
            await this.ionfilelist.closeSlidingItems();
            await toast.present();
        } catch (e) {
            console.log(e);
        }


    }


}
